export default [
  'MP3',
  'AAC',
  '3G2',
  'AIFF',
  'ALAC',
  'AMR',
  'FLAC',
  'M4A',
  'MP2',
  'OGG',
  'WAV',
  'WMA',
] as const;
